import styled from "styled-components";

export const ExerciseIconBox = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
`;

export const ExerciseItem = styled.li`
  display: flex;
  width: 160px;
  padding: 16px;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  box-shadow: ${(props) => props.theme.shadows.box};
  flex-direction: column;
  flex-shrink: 0;
  gap: 12px;

  &:first-of-type {
    ${ExerciseIconBox} {
      background: ${(props) => props.theme.colors.yellow12};

      svg {
        path {
          fill: ${(props) => props.theme.colors.yellow100};
        }
      }
    }
  }

  &:nth-of-type(2) {
    ${ExerciseIconBox} {
      background: ${(props) => props.theme.colors.green12};

      svg {
        path {
          fill: ${(props) => props.theme.colors.green100};
        }
      }
    }
  }

  &:nth-of-type(3) {
    ${ExerciseIconBox} {
      background: ${(props) => props.theme.colors.red12};

      svg {
        path {
          fill: ${(props) => props.theme.colors.red100};
        }
      }
    }
  }

  &:nth-of-type(4) {
    ${ExerciseIconBox} {
      background: ${(props) => props.theme.colors.blue12};

      svg {
        path {
          fill: ${(props) => props.theme.colors.blue100};
        }
      }
    }
  }

  &:nth-of-type(5) {
    ${ExerciseIconBox} {
      background: ${(props) => props.theme.colors.darkgray12};

      svg {
        path {
          fill: ${(props) => props.theme.colors.darkgray100};
        }
      }
    }
  }

  &:active {
    background: ${(props) => props.theme.colors.black2};
    box-shadow: none;
  }
`;

export const ExerciseItemTit = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.text4};
  font-size: 1.5rem;
  font-weight: 700;
  flex-direction: column;
  gap: 5px;

  span {
    color: ${(props) => props.theme.colors.text2};
    font-size: 1.2rem;
    font-weight: 400;
  }
`;
